import { render } from "./MixView.vue?vue&type=template&id=3df558fd&ts=true"
import script from "./MixView.vue?vue&type=script&lang=ts"
export * from "./MixView.vue?vue&type=script&lang=ts"

import "./MixView.vue?vue&type=style&index=0&id=3df558fd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__